<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading || isTesting"
  >
    <div v-if="credentials.docs">
      <el-table
        :data="credentials.docs"
        @sort-change="handleSortChange"
        :default-sort="{ prop: '_id', order: 'descending' }"
        :row-class-name="tableRowClassName"
        border
        stripe
      >
        <el-table-column sortable="custom" prop="_id" label="ID" width="90">
          <template slot-scope="scope">
            <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
            {{ scope.row._id.slice(-6) }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="title" label="Название">
        </el-table-column>

        <el-table-column sortable="custom" prop="type" label="Тип" width="100">
          <template slot-scope="scope">
            {{ credentialTypes.find(t => t.type === scope.row.type)["title"] }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="valute" label="Ключи">
          <template slot-scope="scope">
            <i class="el-icon-key"></i>
          </template>
        </el-table-column>
        <el-table-column
          v-if="session.type <= -1"
          fixed="right"
          label="Действия"
          width="150"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">Удалить</div>
              <el-button
                size="small"
                icon="el-icon-delete"
                @click="handleDeleteCredential(scope.row._id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handlePageChange"
        :current-page.sync="credentials.page"
        :page-size="credentials.limit"
        layout="prev, pager, next, jumper"
        :total="credentials.totalDocs"
      >
      </el-pagination>
    </div>
    <el-collapse>
      <el-collapse-item name="1">
        <template slot="title">
          <i class="header-icon el-icon-plus"></i>
          Добавить
        </template>
        <el-form
          :model="newCred"
          ref="form"
          label-width="200px"
          :inline="false"
          size="normal"
        >
          <el-form-item label="Тип">
            <el-select v-model="newCred.type" filterable>
              <el-option
                v-for="item in credentialTypes"
                :key="item.type"
                :label="item.title"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Название">
            <el-input v-model="newCred.title"></el-input>
          </el-form-item>
          <el-form-item
            v-for="field in getFields(newCred.type)"
            :label="field.label"
            :key="field.key"
            :prop="field.key"
            :rules="
              field.validator
                ? { validator: field.validator, trigger: 'blur' }
                : {}
            "
          >
            <el-input
              v-if="field.type === 'input'"
              v-model="newCred[field.key]"
            ></el-input>
            <el-input
              v-if="field.type === 'text'"
              type="textarea"
              :rows="2"
              v-model="newCred[field.key]"
              :autosize="{ minRows: 2, maxRows: 6 }"
            >
            </el-input>
            <el-input-number
              v-if="field.type === 'number'"
              v-model="newCred[field.key]"
            >
            </el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="addCred">Добавить</el-button>
            <el-button type="primary" @click="testCredential"
              >Проверить</el-button
            >
            <el-button @click="resetNewCred">Очистить</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
import {
  testBitzlato,
  testWhitebit,
  testFirekassa,
  testVanilapay,
  testOkx
} from "@/api";
import credentialTypes from "./credentialTypes";
export default {
  name: "LedgerCredentialsComponent",
  data: () => ({
    credentialTypes,
    newCred: {
      title: "",
      type: "bitzlato"
    },
    isTesting: false
  }),
  computed: {
    ...mapState("ledgerCredentials", ["credentials", "loading"]),
    ...mapState("valutes", ["valutes"]),
    ...mapState("auth", ["session"])
  },
  methods: {
    ...mapActions("ledgerCredentials", [
      "getCredentials",
      "goToPage",
      "changeSorting",
      "addCredential",
      "deleteCredential"
    ]),
    ...mapActions("valutes", ["getValutes", "getSortedValutes"]),
    async testCredential() {
      try {
        this.isTesting = true;
        this.$refs["form"].validate(valid => {
          if (!valid) throw new Error("Ошибки при заполнении формы!");
          return false;
        });
        const credential = this.generateCredential();
        if (this.newCred.type === "bitzlato") {
          const resp = await testBitzlato({
            credential
          });
          this.$message({
            type: "success",
            message: `Ключи успешно проверены!`
          });
        }
        if (this.newCred.type === "whitebit") {
          const resp = await testWhitebit({
            credential
          });
          this.$message({
            type: "success",
            message: `Ключи успешно проверены!`
          });
        }
        if (this.newCred.type === "firekassa") {
          const resp = await testFirekassa({
            credential
          });
          this.$message({
            type: "success",
            message: `Ключи успешно проверены!`
          });
        }
        if (this.newCred.type === "vanilapay") {
          const resp = await testVanilapay({
            credential
          });
          this.$message({
            type: "success",
            message: `Ключи успешно проверены!`
          });
        }
        if (this.newCred.type === "okx") {
          const resp = await testOkx({
            credential
          });
          this.$message({
            type: "success",
            message: `Ключи успешно проверены!`
          });
        }
        this.isTesting = false;
      } catch (error) {
        this.isTesting = false;
        console.log(error);
        this.handleResponseError(error);
      }
    },
    getFields(type) {
      return this.credentialTypes.find(t => t.type === type)["fields"];
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteCredential(id) {
      // const linkedTransactions = await testBitzlato({
      //   pagination: false,
      //   query: { balanceAccount: id }
      // });
      // console.log(linkedTransactions);
      let message = "Вы точно хотите удалить ключи?";
      // if (
      //   linkedTransactions.data.status &&
      //   linkedTransactions.data.result.totalDocs
      // )
      //   message += " У баланса есть связанные транзакции!";

      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await this.deleteCredential(id);
        this.$message({
          type: "success",
          message: `Ключи успешно удалены`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    async handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.changeSorting({ sort });
    },
    handlePageChange(page) {
      this.goToPage({ page });
    },
    resetNewCred() {
      this.newCred = {
        title: "",
        type: "bitzlato"
      };
    },
    generateCredential() {
      const credential = Object.fromEntries(
        this.getFields(this.newCred.type).map(f => {
          return [
            f.key,
            f.isJSON ? JSON.parse(this.newCred[f.key]) : this.newCred[f.key]
          ];
        })
      );
      return credential;
    },
    async addCred() {
      try {
        this.$refs["form"].validate(valid => {
          if (!valid) throw new Error("Ошибки при заполнении формы!");
          return false;
        });
        const credential = this.generateCredential();
        const data = {
          ...this.newCred,
          credential
        };
        const resp = await this.addCredential(data);
        // console.log(resp);
        this.resetNewCred();
        return this.$notify.success({
          title: "Успех",
          message: `Ключи ${resp.data.result.title || ""} созданы!`
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    }
  },
  async mounted() {
    await this.getCredentials();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/credentials.vue